<template>
  <component
    :is="audio ? 'audio' : 'video'"
    ref="videoPlayer"
    :data-setup="JSON.stringify({
      fluid: true,
    })"
    class="video-js vjs-big-play-centered">
  </component>
</template>

<script>
import videojs from 'video.js';
import './dash.min.js';
import './video-js-dash.min.js';
import 'video.js/dist/video-js.css';

export default {
  name: 'video-player',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    disableScrub: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      player: null,
      highestTime: 0,
    };
  },
  mounted() {
    // const overrideNative = false;
    this.player = videojs(this.$refs.videoPlayer, {
      ...this.options,
      html5: {
        dash: {
          setLimitBitrateByPortal: true,
          setMaxAllowedBitrateFor: ['video', 2000],
        },
        // vhs: {
        //   withCredentials: true,
        //   debug: true,
        //   enableWorker: true,
        //   overrideNative: true,
        // },
        // nativeVideoTracks: !overrideNative,
        // nativeAudioTracks: !overrideNative,
        // nativeTextTracks: !overrideNative,
      },
    }, () => {
      this.player.on('ended', this.onEnded);
      this.player.on('ready', this.onReady);
      this.player.on('timeupdate', this.onTimeUpdate);
    });
    videojs.use('*', this.disableForwardScrubbing);
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    play() {
      if (this.player && typeof this.player.play === 'function') {
        this.player.play().catch(() => {});
      }
    },
    onEnded() {
      this.$emit('on-ended');
    },
    onReady() {
      this.$emit('on-ready');
    },
    onTimeUpdate() {
      if (!this.player || !this.player.currentTime) {
        return;
      }
      this.$emit('on-time-update', this.player.currentTime());
    },
    disableForwardScrubbing(player) {
      const $vm = this;
      return {
        setSource(srcObj, next) {
          next(null, srcObj);
        },
        currentTime(time) {
          if (time > $vm.highestTime) {
            $vm.highestTime = time;
          }
          return time;
        },
        setCurrentTime(desiredTime) {
          const currentTime = player.currentTime();
          if (!$vm.disableScrub || desiredTime < $vm.highestTime) {
            return desiredTime;
          }
          return currentTime;
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.video-js {
  height: 450px;
  width: 100%;

  @media only screen and (max-width: $mobile-max) {
    height: 335px;
    width: 100%;
  }
}
</style>
